import { Antrag } from '../types';
import { Component, output } from '@angular/core';
import { EinreichungStep } from '../enums';

@Component({
  selector: 'ebeihilfe-einreichung',
  template:
    '<div einreichung (einreichungStepEmitter)="stepFromDirective($event)" (antragChangeEmitter)="antragFromDirectiveChanged($event)" (hasUiEmitter)="hasUIFlagChanged($event)"></div>',
  styles: [],
  standalone: false,
})
export class EbeihilfeEinreichungComponent {
  public stepChangeEmitter = output<EinreichungStep>();
  public antragChangedEmitter = output<Antrag>();
  public hasUiValueChangedEmitter = output<boolean>();

  public stepFromDirective(einreichungsStep: EinreichungStep): void {
    this.stepChangeEmitter.emit(einreichungsStep);
  }

  public antragFromDirectiveChanged(antrag: Antrag): void {
    this.antragChangedEmitter.emit(antrag);
  }

  public hasUIFlagChanged(hasUi: boolean): void {
    this.hasUiValueChangedEmitter.emit(hasUi);
  }
}
